import React from "react";
import LogNav from "../layout/LoggedNav";
import RecentHistory from "../Billing/RecentHistory";
import MemberCard from "../Billing/MemberCard";
import BillingPayCard from "../BillingPay/BillingPayCard";
import CancelAccount from "../Billing/CancelAccount";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import {STRIPE_KEY} from "../../config.json";

const stripePromise = loadStripe(STRIPE_KEY);

const BillingPay = () => {
  return (
    <>
      <div className="billing">
        <h1 className="billing--title text-jost-sb-50-wt">
          Welcome to your account
        </h1>
        {/* <LogNav /> */}

        <div className="billing__wrap">
          <div className="billing__pay">
            <div>
              <Elements stripe={stripePromise}>
                <MemberCard />
              </Elements>
                <BillingPayCard />
            </div>
            <CancelAccount />
          </div>
          <RecentHistory />
        </div>
      </div>
    </>
  );
};
export default BillingPay;
